import {
  DividerProps as MantineDividerProps,
  Divider as MantineDivider,
} from '@mantine/core';

export type DividerProps = MantineDividerProps;

export const Divider = MantineDivider;

Divider.displayName = 'Divider';
